import { ISkeletonData, Spine } from "@modules/pixi-spine";
import { AtlasResource } from "../../ResourceManager/AtlasResource";
import { JSONResource } from "../../ResourceManager/JSONResource";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import * as PIXI from "pixi.js";
import { Settings } from "../../Settings";
import { Point, Rect, Scale } from "../../MyHelpers";
import { IUniReelPIXIAPP } from "./IUniReelPIXIPP";
export interface UniReelParams {
    basePath: string;
    gameName: string;
}

export class UniReelPIXIAPP implements  IUniReelPIXIAPP {

    protected parameters: UniReelParams = null;
    protected unireel: Spine = null;
    // protected viewContainer: PIXI.Container = null;

    public constructor(params: UniReelParams) {
        this.parameters = {
            basePath: params.basePath,
            gameName: params.gameName,
        }
    }

    public async PrepareResources(resourceManager: IWriteOnlyResourceManager) {
        resourceManager.AddGlobal(new JSONResource(`${this.parameters.basePath}resources/SpineResources/UniReel/UniReel.json`, ResourceIdentifier.Global.ScopedResourceName(`${this.parameters.gameName}-UniReel-JSON`), true));
        resourceManager.AddGlobal(new AtlasResource(`${this.parameters.basePath}resources/SpineResources/UniReel/UniReel.atlas`, ResourceIdentifier.Global.ScopedResourceName(`${this.parameters.gameName}-UniReel-ATLAS`), true));
    }

    protected skeleton: ISkeletonData = null;
    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {

        const jsonUnireel = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`${this.parameters.gameName}-UniReel-JSON`));
        const unireelAsset = await PIXI.Assets.load(jsonUnireel.path);
        this.skeleton = unireelAsset.spineData;
    }
    public Copy(): UniReelPIXIAPP {

        
        const copyInstance = new UniReelPIXIAPP(this.parameters);
        copyInstance.skeleton = this.skeleton;

        return copyInstance;
    }

    private created: boolean = false;
    public Created(): boolean {
        return this.created;
    }

    protected reelContainer: PIXI.Container = null;
    public Create() {

        if (this.created) {
            return;
        }

        this.unireel = new Spine(this.skeleton);
        this.unireel.sortableChildren = true;
        // this.unireel.cullable = true;
        if (this.unireel.spineData.animations.length > 0) {
            this.unireel.state.setAnimation(0, "BG_AnimatedMarcoReels", true);
        }

        const reelsContainer = (this.unireel.children as PIXI.Container[]).find(c => c.name == "reelsContainer");
        this.reelContainer = new PIXI.Container();
        this.reelContainer.name = "UniReelContainer";
        reelsContainer.addChild(this.reelContainer);
        this.reelContainer.scale.set(1, -1);
        // this.reelContainer = new PIXI.Container();
        // this.reelContainer.name = "UniReelContainer";
        // this.reelContainer.addChild(this.unireel);
        // this.reelContainer.addChild(this.reelContainer);
        // this.viewContainer = new PIXI.Container();
        // this.viewContainer.name = "UniReelContainer";
        // this.viewContainer.addChild(this.unireel);
        this.created = true;
        this.OnResize();
    }

    public GetView(): PIXI.Container {
        return this.unireel;
    }

    public GetReelsContainer(): PIXI.Container {
        return this.reelContainer;
    }
    public Destroy() {

        if (!this.created) return;
        this.created = false;
        this.unireel?.state?.clearTracks();
        if (!this.unireel.destroyed)
        {
            this.unireel?.destroy({ children: true, texture: false, baseTexture: false });
        }
    }
    protected unireelRect: Rect = null;
    public OnResize() {

        const pointA = this.skeleton.bones.find(b => b.name == "reelsPointA");
        const pointB = this.skeleton.bones.find(b => b.name == "reelsPointB");

        const width = Math.abs(pointA.x - pointB.x) + (pointA.x * 2);
        const height = Math.abs(pointA.y - pointB.y) + (pointA.y * 2);

        const outerRect = new Rect(
            0,
            0,
            width,
            height
        );

        const scaleX = Scale.W(1920) / outerRect.width;
        const scaleY = Scale.H(1080) / outerRect.height;
        const scale = Math.min(scaleX, scaleY);
        this.unireel.scale.set(scale);



        this.unireelRect = new Rect(
            pointA.x,
            Math.abs(pointA.y * (scale * 1.75)),
            Math.abs(pointA.x - pointB.x),
            pointA.y - pointB.y
        );
    }


    public GetReelsPosition(): Rect {
        return this.unireelRect;
    }

}